import { useState } from "react";

import { Button } from "@/components/clickable";
import { TextField } from "@/components/forms";
import { VStack } from "@/components/layout";
import useAuthContext from "./hooks/use-auth-context";

export default function VerifyCodeFields({ email, onReturn, onCodeVerified }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { verifyOtp } = useAuthContext();

  const onSubmit = () => {
    setIsLoading(true);
    verifyOtp({ code, email })
      .then(() => onCodeVerified())
      .catch(() => {
        setError(true);
        setIsLoading(false);
      });
  };

  return (
    <VStack className="w-full items-center gap-6">
      <div className="w-full">
        <TextField
          onChange={(e) => setCode(e.target.value)}
          label="Enter the code"
          placeholder="6-digit code"
          description={`Code sent to ${email}`}
        />
      </div>

      {error && (
        <p className="text-xs font-semibold text-red-500">Incorrect email</p>
      )}

      <div className="w-full">
        <Button
          isLoading={isLoading}
          color="green"
          className="w-full"
          onClick={onSubmit}
        >
          Submit
        </Button>
      </div>

      <p className="-mt-4 text-center">
        <button className="text-sm" onClick={onReturn}>
          Use different email
        </button>
      </p>
    </VStack>
  );
}
